<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    :fullscreen="fullscreen"
    append-to-body
    top="0"
    :width="width"
    :custom-class="classList"
    v-bind="$attrs"
    v-on="$listeners"
    v-ps="disableScroll ? false : '.el-dialog__body'"
    class="base-dialog"
    :modal-fade="false"
  >
    <template slot="title">
      <div v-if="$slots.header" class="header">
        <slot name="header"></slot>
        <span v-if="!hideClose" class="icon-close" @click="$emit('update:visible', false)">
          <svg-icon icon-class="close"></svg-icon>
        </span>
      </div>
    </template>
    <slot></slot>
    <template slot="footer">
      <div v-if="$slots.footer" class="footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "base-dialog",
  props: {
    visible: Boolean,
    width: {
      type: String,
      default: "560px"
    },
    height: String,
    fullscreen: {
      type: Boolean,
      default: false
    },
    hideClose: Boolean,
    disableScroll: Boolean
  },
  computed: {
    classList() {
      return this.fullscreen ? "is-fullscreen" : ""
    },
    dialogBody() {
      return this.$el.querySelector(".el-dialog__body")
    }
  },
  watch: {
    height: {
      handler() {
        this.$el.querySelector("div.el-dialog").style.height = this.height
      }
    }
  },
  mounted() {
    this.$el.querySelector("div.el-dialog").style.height = this.height
  },
  methods: {
    scrollToTop() {
      this.dialogBody.scrollTop = 0
    },
    scrollToBottom() {
      this.dialogBody.scrollTop = this.dialogBody.scrollHeight - this.dialogBody.clientHeight
    }
  }
}
</script>

<style lang="scss" scoped>
.base-dialog {
  min-width: 560px;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: none !important;
  .header {
    display: flex;
    align-items: center;
    padding: 0 24px;
    font-size: $font-size-title-first;
    height: 52px;
    border-bottom: 2px solid #f5f5f5;
    .icon-close {
      cursor: pointer;
      margin-left: auto;
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 24px;
    height: 52px;
    border-top: 2px solid #f5f5f5;
  }
  ::v-deep .el-dialog {
    position: relative;
    margin: 0;
    display: flex;
    max-height: 100%;
    flex-direction: column;
    &.is-fullscreen {
      max-height: 100%;
    }
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 100px;
      padding: 18px 22px;
      .el-loading-spinner {
        margin-top: 0;
      }
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
}
</style>
